import { CheckCircle } from 'lucide-react'

interface Step {
  id: string
  name: string
  description: string
}

interface BookingStepperProps {
  steps: Step[]
  currentStep: number
}

const BookingStepper = ({ steps, currentStep }: BookingStepperProps) => {
  return (
    <div className="flex justify-center">
      {/* Mobile: compact pill indicator + current step description */}
      <div className="flex sm:hidden flex-col items-center gap-1.5 w-full">
        <div className="flex items-center justify-center gap-1.5">
          {steps.map((_, index) => (
            <div
              key={index}
              className={`h-1 rounded-full transition-all duration-300 ${
                index < currentStep
                  ? 'w-5 bg-primary-500'
                  : index === currentStep
                    ? 'w-7 bg-primary-500'
                    : 'w-3 bg-gray-300'
              }`}
            />
          ))}
        </div>
        <p className="text-center text-[11px] text-gray-500 leading-tight">
          {steps[currentStep]?.description}
        </p>
      </div>

      {/* Desktop: compact centered stepper */}
      <div className="hidden sm:flex items-start justify-center w-full max-w-2xl mx-auto">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-start">
            <div className="flex flex-col items-center w-28 md:w-32">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${
                  index < currentStep
                    ? 'bg-primary-500 border-primary-500 text-white'
                    : index === currentStep
                      ? 'bg-primary-100 border-primary-500 text-primary-600'
                      : 'bg-gray-100 border-gray-300 text-gray-400'
                }`}
              >
                {index < currentStep ? (
                  <CheckCircle className="h-4 w-4" />
                ) : (
                  <span className="font-semibold text-xs">{index + 1}</span>
                )}
              </div>
              <p
                className={`mt-1 text-[11px] font-medium leading-tight text-center ${
                  index <= currentStep ? 'text-gray-900' : 'text-gray-400'
                }`}
              >
                {step.name}
              </p>
              <p className="text-[10px] text-gray-500 mt-0.5 text-center leading-tight px-0.5">
                {step.description}
              </p>
            </div>

            {index < steps.length - 1 && (
              <div
                className={`w-16 sm:w-20 md:w-28 lg:w-36 h-0.5 mx-2 md:mx-4 mt-4 transition-all duration-300 ${
                  index < currentStep ? 'bg-primary-500' : 'bg-gray-300'
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default BookingStepper
